import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../components/modules/QNATable/ui.helpers";

const QNAUIContext = createContext();

export function useQNAUIContext() {
  return useContext(QNAUIContext);
}

export const QNAUIConsumer = QNAUIContext.Consumer;

export function QNAUIProvider({ QNAUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const { openQNADetailDialog } = QNAUIEvents;

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openQNADetailDialog,
  };

  return (
    <QNAUIContext.Provider value={value}>
      {children}
    </QNAUIContext.Provider>
  );
}
